export default function ApiURL() {
   // return "http://127.0.0.1:3000"
   return "https://s3052ckb5l.execute-api.us-east-2.amazonaws.com/Prod"
}

export const AuthPoolData = {
   UserPoolId: 'us-east-2_HKGp7vXyi',
   ClientId: '57vlacof5lvfslv5o7vdm79p6',

}